/**
 * Import Dialog Component
 * 
 * Dialog for importing Maßnahmen from Excel files.
 * Extracted from Shifts.jsx for modularity.
 */
import React from 'react';
import { Button } from '../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';
import { FileSpreadsheet, Upload, Loader2 } from 'lucide-react';

const ImportDialog = ({
  open,
  onOpenChange,
  locations,
  importing,
  onImport,
  onDownloadTemplate,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-md w-[calc(100vw-1rem)] sm:w-full p-4 sm:p-6 max-h-[92vh] overflow-y-auto"
        onCloseAutoFocus={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileSpreadsheet className="h-5 w-5" />
            Maßnahmen importieren
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-2 sm:pt-4">
          <div className="bg-muted/50 rounded-lg p-4 text-sm space-y-2">
            <p className="font-medium">So funktioniert der Import:</p>
            <ol className="list-decimal list-inside space-y-1 text-muted-foreground">
              <li>Laden Sie die <button onClick={onDownloadTemplate} className="text-primary underline">Excel-Vorlage</button> herunter</li>
              <li>Füllen Sie die Maßnahmen in der Vorlage aus</li>
              <li>Verwenden Sie die Standort-IDs (siehe unten)</li>
              <li>Laden Sie die ausgefüllte Datei hier hoch</li>
            </ol>
          </div>

          {/* Standort-IDs Referenz */}
          <div className="border rounded-lg p-3 max-h-40 overflow-y-auto">
            <p className="text-xs font-medium text-muted-foreground mb-2">Verfügbare Standorte:</p>
            <div className="space-y-1">
              {locations.map(loc => (
                <div key={loc.id} className="flex items-center justify-between text-xs bg-muted/30 rounded px-2 py-1">
                  <span className="font-medium">{loc.name}</span>
                  <code className="text-[10px] bg-muted px-1.5 py-0.5 rounded font-mono select-all">{loc.id}</code>
                </div>
              ))}
            </div>
          </div>
          
          <div className="border-2 border-dashed border-muted-foreground/25 rounded-lg p-8 text-center">
            <input
              type="file"
              accept=".xlsx,.xls"
              onChange={onImport}
              className="hidden"
              id="import-file"
              disabled={importing}
            />
            <label 
              htmlFor="import-file" 
              className="cursor-pointer flex flex-col items-center gap-2"
            >
              {importing ? (
                <Loader2 className="h-10 w-10 text-muted-foreground animate-spin" />
              ) : (
                <Upload className="h-10 w-10 text-muted-foreground" />
              )}
              <span className="text-sm font-medium">
                {importing ? 'Importiere...' : 'Excel-Datei auswählen'}
              </span>
              <span className="text-xs text-muted-foreground">
                .xlsx oder .xls
              </span>
            </label>
          </div>

          <div className="flex justify-end pt-2 border-t">
            <Button variant="outline" onClick={() => onOpenChange(false)} className="w-full sm:w-auto">
              Schließen
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImportDialog;
